"use client"

import type { IQuestionAndAnswer } from "src/lib/types/QuestionAndAnswer";
import styles from "./QAQuestion.module.css";
import { useState } from "react";
import RichText from "src/components/richtext/Richtext";
import classNames from "classnames";

type QAQuestionProps = {
    question: IQuestionAndAnswer;
}

export default function QAQuestion({ question }: QAQuestionProps) {
    const [isVisible, setIsVisible] = useState(false);

    return <div className={styles.SQuestionContainer}>
        <button className={classNames(styles.SQuestion, { [styles.SQuestion_active]: isVisible })} aria-controls={question._key} onClick={() => setIsVisible(!isVisible)}>{question.question}</button>
        <div className={classNames(styles.SAnswer, { [styles.SAnswer_showing]: isVisible })} aria-hidden={!isVisible} id={question._key}>
            <RichText value={question.answer} />
        </div>
    </div>
}